import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'configuration-planning-tab-1-part',
	standalone: true,
	templateUrl: './configuration-planning-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./configuration-planning-tab-1.part.scss`],
})
export class ConfigurationPlanningTab1Part {
}
